import "./News.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedNewsCarousel from "./sections/FeaturedNewsCarousel";
import NewsArchiveGrid from "./sections/NewsArchiveGrid";
import NewsletterSubscription from "./sections/NewsletterSubscription";
import Footer from "@/reusable_sections/Footer";
export default function NewsPage() {
  return <div>
      <Header />
      <FeaturedNewsCarousel />
      <NewsArchiveGrid />
      <NewsletterSubscription />
      <Footer />
    </div>;
}